import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {AuthService} from '../../services/auth.service';
import {environment} from '../../../environments/environment';
import {catchError} from 'rxjs/operators';
import {ToastService} from '../../services/toast.service';
import {LanguageService} from '../../services/language.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private auth: AuthService,
        private languageService: LanguageService,
        private toast: ToastService
    ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!request || !request.url || !!request.headers.get('x-access-token')
            || (/^http/.test(request.url) && !(environment.apiUrl && request.url.startsWith(environment.apiUrl))
            && !(environment.newApiUrl && request.url.startsWith(environment.newApiUrl))
            && !(environment.sendMessageUrl && request.url.startsWith(environment.sendMessageUrl)))
        ) {
            return next.handle(request);
        }

        const params = request.params;
        const token = request.url.indexOf(environment.apiUrl) == 0 ? this.auth.getAccessToken() : this.auth.getNewAccessToken();

        const options = {
            Authorization: `Bearer ${token}`
        };

        request = request.clone({
            headers: new HttpHeaders(options),
            params
        });

        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401 && !request.url.startsWith(environment.newApiUrl)) {
                this.languageService.translate('message.sessionExpired').then(message => {
                    this.toast.error(message);
                    window.location.href = '/auth/signin';
                })
            } else {
                return throwError(err);
            }
        }));
    }
}
